const FieldUserName = 'username';

const FieldGivenName = 'given_name';
const FieldFamilyName = 'family_name';
const FieldMiddleName = 'middle_name';
const FieldNames = [FieldGivenName, FieldFamilyName, FieldMiddleName];

export const XSSDisallowChars: RegExp = /[\/\\<>$+{}]/;
export const CharacterDisallowed = '\\, /, <, >, $, +, {, }';

export enum FieldDataType {
  UserName = 'USERNAME',
  Text = 'TEXT',
  Password = 'PASSWORD',
  Email = 'EMAIL',
  Mobile = 'MOBILE'
}

export enum UserIdType {
  Mobile = 'mobile',
  Email = 'email',
  Username = 'user_name'
}

export enum FieldType {
  System = 'SYSTEM',
  Custom = 'CUSTOM'
}

export interface FieldDefinition {
  disallowedCharacters?: RegExp | string[];
  pattern?: RegExp | string;
  invalidmobile?: boolean;
}

export interface LocaleText {
  verificationRequired?: string;
  locale?: string;
  language?: string;
  pattern?: string;
  disallowedCharacters?: string;
  name?: string;
  required?: string
  [key: string]: string | undefined
}

export interface Field {
  dataType: FieldDataType;
  fieldKey: string;
  fieldType: FieldType;
  fieldDefinition?: FieldDefinition;
  localeText?: LocaleText;
  required: boolean;
  is_group?: boolean;
  order?: number;
  parent_group_id?: string;
  readOnly?: boolean;
}

export interface FieldValue<T> extends Field{
  value: T
}

export interface Translation {
  key: string;
  params: { [key: string]: string };
}

export interface AddValidation {
  translation: Translation;
  setLocale: (translation: string) => Field;
  field: Field;
}


export const isUserNameField = (field: Field, userIdType: string): boolean => {
  if (userIdType === UserIdType.Mobile || userIdType === UserIdType.Email) {
    return false;
  }
  if (field.dataType === FieldDataType.UserName) {
    return field.fieldKey === userIdType;
  }
  // This condition is added to compensate username given as TEXT dataType when seeding in SYSTEM
  if (field.dataType === FieldDataType.Text && field.fieldType === FieldType.System
    && userIdType === UserIdType.Username) {
    return field.fieldKey === FieldUserName;
  }
  return false;
};


export const addXSSValidationToNameFields = (field: Field): AddValidation | undefined => {
  if (isXSSRestrictedFields(field)) {
    if (!field.fieldDefinition) {
      field.fieldDefinition = {};
    }
    field.fieldDefinition.disallowedCharacters = XSSDisallowChars;
    return {
      translation: {
        key: 'FORM.VALIDATION.CHARACTERS_NOT_ALLOWED',
        params: { characters: CharacterDisallowed }
      },
      setLocale: (translation: string): Field => {
        if (!field.localeText) {
          field.localeText = {};
        }
        field.localeText.disallowedCharacters = translation;
        return field;
      },
      field
    };
  }
  return undefined;
};

const isXSSRestrictedFields = (field: Field): boolean => {
  return field.dataType === FieldDataType.Text && field.fieldType === FieldType.System
    && FieldNames.includes(field.fieldKey);
};
